import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { colors, fonts } from '../../assets/constStyles';
import { paths } from '../../consts';

export const ButtonStyled = styled(Button)`
  border-color: ${colors.colorRed} !important;
  background-color: ${colors.colorRed} !important;
  color: white !important;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  height: 54px;
  border-radius: 10px !important;
  font-size: 16px !important;
  font-family: ${fonts.font2};
  white-space: nowrap;
  
  &:hover {
    border-color: ${colors.colorMutedYellow} !important;
    background-color: ${colors.colorMutedYellow} !important;
    transition: all 0.3s ease;
  }

  @media (max-width: 768px) {
    padding: 10px 20px!important;
    font-size: 14px!important;
  }
`;

interface IButtonMain {
  text?: string;
  route?: string;
  targetBlank?: boolean;
}

export const ButtonMainRed: React.FC<IButtonMain> = ({ text, route, targetBlank }) => (
    <Link to={route || paths.MAIN} target={targetBlank ? '_blank' : '_parent'}>
        <ButtonStyled>
            {text}
        </ButtonStyled>
    </Link>
);
